module.exports = __webpack_public_path__ + "media/common/logo-bcddfa35.svg";